const data = {
  p1: {
    title: "易企聊",
    subtitle: "用AI轻松连接客户，推广转化一步到位",
    link: "https://aibeings-vip.xiaoice.com/"
  },
  p2: {
    title1: "融合AI数字员工与大模型对话",
    title2: '为企业打造全新的品牌展示与客户运营窗口',
    subtitle: "品牌展示与客户运营窗口",
    desc: [
      "生动呈现企业形象、产品信息与IP故事，支持留咨与一键转发，快速链接业务资源",
      "打造企业号与员工号双矩阵，让品牌形象与销售转化同频",
      "适配线下展会、线上投流、客户转介绍等多元营销场景，支持多语言互动协助企业拓客，提升转化",
      "突破人力与时间限制，以低成本、高效率的方式，开启智能化客户运营与全域增长新局面"
    ]
  },
  p3: {
    title: "产品优势",
    list1: [
      {
        title: "全天候AI接待",
        desc: "7×24小时在线讲解与答疑，无需人工值守",
        icon: "p3Icon1"
      },
      {
        title: "一键搭建企业号/员工号",
        desc: "零门槛上手，快速完成品牌窗口建设",
        icon: "p3Icon3"
      }
    ],
    list2: [
      {
        title: "AI驱动营销话术",
        desc: "灵活设置，精准匹配不同客户与场景",
        icon: "p3Icon3"
      },
      {
        title: "多渠道触达",
        desc: "结合微信广告投流、朋友圈、社群等渠道，放大转化效果",
        icon: "p3Icon4"
      }
    ]
  }
};
export default data;